//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CookieService from "../../services/CookieService";

const Modal = () => import('../Modal/Modal');
const Wrapper = () => import('../Layout/Wrapper');
const Btn = () => import('../Button/Btn');
const Icon = () => import('../Icon/Icon');
const ServerContent = () => import('../Layout/ServerContent');
const FormSwitch = () => import('../Form/Input/Toggle/FormSwitch');
const InfoList = () => import('../List/InfoList/InfoList');
const InfoListItem = () => import('../List/InfoList/InfoListItem');

export default {
    name: "CookieBanner",

    components: {Modal, InfoListItem, InfoList, FormSwitch, Icon, Btn, Wrapper, ServerContent},

    data() {
        return {
            isActive: false,

            currentContent: null,

            // Whether Google Analytics is enabled
            gaEnabled: true,

            // Whether Google AdSense is enabled
            gasEnabled: true,

            visibleCookies: null,

            appearTimeout: null
        }
    },

    computed: {
        // The various texts to display
        text() {
            return {
                title: this.$t('cookie_banner.title'), // The title to show above the banner content text
                accept: this.$t('cookie_banner.accept'), // The text of the 'accept' button
                settings: this.$t('label.settings'), // The text for the button to toggle the custom selection
                privacy: this.$t('label.privacy'), // The text for the button to show the privacy policy
                imprint: this.$t('label.imprint'), // The text for the button to show the imprint
                back: this.$t('action.back'), // The text for the back button on the custom selection page
                content: this.$t('cookie_banner.content'),
                custom_content: this.$t('cookie_banner.custom_content')
            }
        },

        modalTitle() {
            let title = this.text.title;

            if (this.currentContent === 'privacy') {
                return `${title}: ${this.$t('label.privacy')}`;
            }
            if (this.currentContent === 'imprint') {
                return `${title}: ${this.$t('label.imprint')}`;
            }

            return title;
        },

        // The customizable cookies
        cookies() {
            const essentialCookies = [
                {
                    title: this.$t('cookie_banner.cookies.authentication.title'),
                    text: this.$t('cookie_banner.cookies.authentication.text')
                },
                {
                    title: this.$t('cookie_banner.cookies.settings.title'),
                    text: this.$t('cookie_banner.cookies.settings.text')
                },
                {
                    title: this.$t('cookie_banner.cookies.stripe.title'),
                    text: this.$t('cookie_banner.cookies.stripe.text')
                },
            ];

            return [
                {
                    title: this.$t('cookie_banner.cookies.essential.title'),
                    text: this.$t('cookie_banner.cookies.essential.text'),
                    cookies: essentialCookies,
                    disabled: true,
                    value: true,
                    handler: () => {
                    }
                },
                {
                    title: this.$t('cookie_banner.cookies.statistics.title'),
                    text: this.$t('cookie_banner.cookies.statistics.text'),
                    cookies: [
                        {
                            title: this.$t('cookie_banner.cookies.statistics.ga.title'),
                            text: this.$t('cookie_banner.cookies.statistics.ga.text'),
                        },
                        {
                            title: this.$t('cookie_banner.cookies.statistics.gtm.title'),
                            text: this.$t('cookie_banner.cookies.statistics.gtm.text'),
                        },
                    ],
                    disabled: false,
                    value: this.gaEnabled,
                    handler: this.toggleGoogleAnalytics
                },
                {
                    title: this.$t('cookie_banner.cookies.ads.title'),
                    text: this.$t('cookie_banner.cookies.ads.text'),
                    cookies: [
                        {
                            title: this.$t('cookie_banner.cookies.ads.gas.title'),
                            text: this.$t('cookie_banner.cookies.ads.gas.text'),
                        }
                    ],
                    disabled: false,
                    value: this.gasEnabled,
                    handler: this.toggleGoogleAdSense
                }
            ];
        },

        gaDisableCookieName() {
            return this.$config.gtmId ? `ga-disable-${this.$config.gtmId}` : null;
        }
    },

    mounted() {
        this.$nextTick(function () {
            if (this.hasCookie(CookieService.COOKIE_NAME_SETTINGS_COOKIE_CONSENT)) {
                this.gaEnabled = !this.hasCookie(this.gaDisableCookieName);
                if (this.gaEnabled) {
                    this.enableGoogleAnalytics();
                } else {
                    this.disableGoogleAnalytics();
                }

                this.gasEnabled = !this.hasCookie(CookieService.COOKIE_NAME_SETTINGS_ADS_DISABLED);
                if (this.gasEnabled) {
                    this.enableGoogleAdSense();
                } else {
                    this.disableGoogleAdSense();
                }
            }

            // Add a timeout to not immediately show the banner on page load
            this.appearTimeout = setTimeout(() => {
                this.isActive = !this.hasCookie(CookieService.COOKIE_NAME_SETTINGS_COOKIE_CONSENT);
            }, 3000);
        });
    },

    beforeDestroy() {
        if (this.appearTimeout) {
            clearTimeout(this.appearTimeout);
        }
    },

    methods: {

        showContent(type) {
            this.currentContent = type;
        },

        hideMoreInfo() {
            this.currentContent = null;
        },

        /**
         * Accepts the cookie banner and hides it.
         */
        accept() {
            // We set a shorter cookie persistence interval when any critical setting is disabled,
            // so the user can rethink his decision more often
            let expirationDays = 365;

            if (this.gaEnabled) {
                this.enableGoogleAnalytics();
            } else {
                this.disableGoogleAnalytics();
                expirationDays = 90;
            }

            if (this.gasEnabled) {
                this.enableGoogleAdSense();
            } else {
                this.disableGoogleAdSense();
                expirationDays = 90;
            }

            this.setCookie(CookieService.COOKIE_NAME_SETTINGS_COOKIE_CONSENT, expirationDays);
            this.isActive = false;
        },

        toggleGoogleAnalytics(value) {
            this.gaEnabled = value;
        },

        enableGoogleAnalytics() {
            if (this.$config.gtmId) {
                this.$analytics.init(this.$config.gtmId)
                this.removeCookie(this.gaDisableCookieName)
            }
        },

        disableGoogleAnalytics() {
            if (this.$config.gtmId) {
                this.setCookie(this.gaDisableCookieName)
            }
        },

        toggleGoogleAdSense(value) {
            this.gasEnabled = value;
        },

        enableGoogleAdSense() {
            if (this.$ads) {
                this.$ads.allow();
            }
            this.removeCookie(CookieService.COOKIE_NAME_SETTINGS_ADS_DISABLED)
        },

        disableGoogleAdSense() {
            this.setCookie(CookieService.COOKIE_NAME_SETTINGS_ADS_DISABLED)
        },

        hasCookie(name) {
            return (new CookieService(name)).get() === 'true';
        },

        setCookie(name, expirationDays = 365) {
            (new CookieService(name)).domain(this.getCookieDomain()).path('/').expiresInDays(expirationDays).set('true');
        },

        removeCookie(name) {
            (new CookieService(name)).domain(this.getCookieDomain()).path('/').remove();
        },

        getCookieDomain() {
            const hostnameParts = window.location.hostname.split('.');

            // Support for localhost
            if (hostnameParts.length === 1) {
                return hostnameParts[0];
            }

            // Extract the main domain for all subdomains
            return hostnameParts[hostnameParts.length - 2] + '.' + hostnameParts[hostnameParts.length - 1];
        }
    }
}
